var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { createGenerateClassName, StylesProvider, ThemeProvider as MuiThemeProvider, } from "@material-ui/styles";
import { theme as defaultTheme } from "./theme";
// handle the possibility of multiple React roots. This ensures both use the same generator.
var defaultClassNameGenerator = createGenerateClassName();
export var ThemeProvider = function (_a) {
    var _b = _a.injectFirst, injectFirst = _b === void 0 ? true : _b, _c = _a.theme, theme = _c === void 0 ? defaultTheme : _c, disableStylesProvider = _a.disableStylesProvider, _d = _a.generateClassName, generateClassName = _d === void 0 ? defaultClassNameGenerator : _d, children = _a.children, stylesProviderProps = __rest(_a, ["injectFirst", "theme", "disableStylesProvider", "generateClassName", "children"]);
    // We want this to be present by default, but if a ThemeProvider is nested we only want to render one of the StylesProvder components
    if (disableStylesProvider) {
        return React.createElement(MuiThemeProvider, { theme: theme }, children);
    }
    return (React.createElement(StylesProvider, __assign({ injectFirst: injectFirst, generateClassName: generateClassName }, stylesProviderProps),
        React.createElement(MuiThemeProvider, { theme: theme }, children)));
};
